<script>
	import LayoutBase from '$lib/components/layouts/LayoutBase.svelte';
	import FooterPrimary from '$lib/components/FooterPrimary.svelte';
	import { app } from '$lib/stores/app/store';
	import { registerEmail } from '$lib/stores/user/action';
	import { UsernameTypes } from '$lib/utils/constants';
	import ActivitiesSection from './components/ActivitiesSection.svelte';
	import FeaturesSection from './components/FeaturesSection.svelte';
	import HeroSection from './components/HeroSection.svelte';
	import HomeFooter from './components/HomeFooter.svelte';
	import HomeHeader from './components/HomeHeader.svelte';
	import HomeschoolSection from './components/HomeschoolSection.svelte';
	import LearningPathSection from './components/LearningPathSection.svelte';
	import ProspectRegisterCard from './components/ProspectRegisterCard.svelte';
	import SubjectsSection from './components/SubjectsSection.svelte';
	import getPageConfig from './__config/page-configuration';
	import HomeDividerSm from './components/HomeDividerSm.svelte';
	import HomeDividerLg from './components/HomeDividerLg.svelte';

	$: ({
		homeHeaderContent,
		heroSectionContent,
		homeDividerSmContent,
		learningPathSectionContent,
		homeDividerLgContent,
		subjectsSectionContent,
		homeschoolSectionContent,
		activitiesSectionContent,
		featuresSectionContent,
		prospectRegisterContent,
		homeFooterContent,
		primaryFooterContent
	} = getPageConfig($app));

	/**
	 * @param {{ detail: { email: string; }; }} event
	 */
	async function onProspectSubmit(event) {
		const { email } = event?.detail;
		if (email) {
			await registerEmail(
				{
					email,
					countryAbbrv: $app.meta.viewerCountry,
					usernameType: UsernameTypes.EMAIL
				},
				{
					redirect: true
				}
			);
		}
	}
</script>

<LayoutBase>
	<HomeHeader slot="header" content={homeHeaderContent} />
	<div slot="content">
		<HeroSection content={heroSectionContent} />
		<HomeDividerSm content={homeDividerSmContent} />
		<LearningPathSection content={learningPathSectionContent} />
		<HomeDividerLg content={homeDividerLgContent} />
		<SubjectsSection content={subjectsSectionContent} />
		<HomeschoolSection content={homeschoolSectionContent} />
		<ActivitiesSection content={activitiesSectionContent} />
		<FeaturesSection content={featuresSectionContent} />
		<ProspectRegisterCard on:submit={onProspectSubmit} content={prospectRegisterContent} />
		<HomeFooter content={homeFooterContent} />
	</div>
	<FooterPrimary slot="footer" content={primaryFooterContent} />
</LayoutBase>
